/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {
    LoadableStateInterface, LoadStatus, LoadStatusInterface,
    PaginatableStateInterface, PaginationInformationInterface,
} from '@/store/types';
import {CommunityChallengeInterface} from '@/store/modules/community-challenge/types';

/**
 * Community challenges module state interface.
 * Represents a community challenge listing module including.
 */
export interface CommunityChallengesStateInterface extends PaginatableStateInterface, LoadableStateInterface {
    challenges: CommunityChallengeInterface[];
    timestamp: number;
}

/**
 * Community challenges module state class.
 * Provides initial state.
 */
export class CommunityChallengesState implements CommunityChallengesStateInterface {
    public challenges: CommunityChallengeInterface[] = [];
    public timestamp: number = 0;
    public pagination: PaginationInformationInterface = {
        totalItems: 0,
        current: '',
        first: '',
        next: '',
        previous: '',
        last: '',
    };
    public loadStatus: LoadStatusInterface = new LoadStatus();
}
